$(function(){
    console.log('-------cellec-cart.js--------')
    /* 設定 */
    var stock_sikiiti = 3
    var text_stock = '在庫あり'
    var text_stock_few = '残りわずか'
    var text_nostock = 'SOLDOUT'
    
    /* 設定 */
    console.log(ob)
    var html_docs = ''
    if(ob.n_options==2){
        //オプション数が２つの場合
        for(var i=0;i<ob.variants.length;i++){
            var option1 = ob.variants[i]
            html_docs+='<li class="n_option2">\n'
            html_docs+='<div class="box">\n'
            if(option1.image != ''){
                html_docs+='<img src="https://cdn.shopify.com/s/files/1/0481/4602/2552/$$img$$" alt="">\n'.replace('$$img$$',option1.image)
            }else{
                html_docs+='<img src="https://cdn.shopify.com/s/files/1/0481/4602/2552/files/white.jpg?v=1718178503" alt="">\n'
            }
            
            html_docs+='<p class="title">$$title$$</p>\n'.replace('$$title$$',option1.name)
            html_docs+='<a href="" href="" class="js-btn-childopen" data-btn="$$id$$"></a>\n'.replace('$$id$$',i)
            html_docs+='</div>\n'
            html_docs+='<ul class="option2" id="js-option-$$id$$">\n'.replace('$$id$$',i)
            for(var i2=0;i2<option1.variants.length;i2++){
                var option2 = option1.variants[i2]
                if(option2.inventory_quantity >= stock_sikiiti){
                    var stock_kubun = text_stock
                }else if(option2.inventory_quantity == 0){
                    var stock_kubun = text_nostock
                }else{
                    var stock_kubun = text_stock_few
                }
                html_docs+='<li>\n'
                html_docs+='<div class="info">\n'
                html_docs+='<p class="title">$$title$$ / $$stock_kubun$$</p>\n'.replace('$$title$$',option2.name).replace('$$stock_kubun$$',stock_kubun)
                html_docs+='<p class="delivery">$$nouki$$</p>\n'.replace('$$nouki$$',option2.nouki)
                html_docs+='</div>\n'
                html_docs+='<form action="/cart/add" method="POST">\n'
                html_docs+='<input type="hidden" name="form_type" value="product">\n'
                html_docs+='<input type="hidden" name="utf8" value="✓">\n'
                html_docs+='<input type="hidden" name="quantity" value="1">\n'
                html_docs+='<input type="hidden" name="id" value="$$id$$">\n'.replace('$$id$$',option2.id)
                if(option2.inventory_quantity>0){
                    html_docs+='<button type="submit" class="js-cart-add" data-id="$$id$$" data-price="$$price$$"><img src="https://cdn.shopify.com/s/files/1/0481/4602/2552/files/product_btn_cartin.png?v=1700836216" class="js-notincart"><span class="js-incart">カートに入りました</span></button>\n'.replace('$$id$$',option2.id)
                }else{
                    html_docs+='<button disabled class="nostock"><img src="https://cdn.shopify.com/s/files/1/0481/4602/2552/files/product_btn_soldout.png?v=1700836216"></button>\n'
                }
                html_docs+='</form>\n'
                html_docs+='</li>\n'
            }
            html_docs+='</ul>\n'
            html_docs+='</li>\n'
        }
    }else{
         //オプション数が１つの場合
        for(var i=0;i<ob.variants.length;i++){
            var option1 = ob.variants[i]
            html_docs+='<li class="n_option1">\n'
            html_docs+='<div class="box">\n'
            if(option1.image !=''){
                html_docs+='<img src="https://cdn.shopify.com/s/files/1/0481/4602/2552/$$img$$" alt="">\n'.replace('$$img$$',option1.image)
            }else{
                html_docs+='<img src="https://cdn.shopify.com/s/files/1/0481/4602/2552/files/white.jpg?v=1718178503" alt="">\n'
            }
            
            var option2 = option1.variants[0]
            if(option2.inventory_quantity >= stock_sikiiti){
                var stock_kubun = '在庫あり'
            }else if(option2.inventory_quantity == 0){
                var stock_kubun = 'SOLDOUT'
            }else{
                var stock_kubun = '残りわずか'
            }
            html_docs+='<div class="info">\n'
            html_docs+='<p class="title">$$title$$ / $$stock_kubun$$</p>\n'.replace('$$title$$',option1.name).replace('$$stock_kubun$$',stock_kubun)
            html_docs+='<p class="delivery">$$nouki$$</p>\n'.replace('$$nouki$$',option2.nouki)
            html_docs+='</div>\n'
            html_docs+='<form action="/cart/add" method="POST">\n'
            html_docs+='<input type="hidden" name="form_type" value="product">\n'
            html_docs+='<input type="hidden" name="utf8" value="✓">\n'
            html_docs+='<input type="hidden" name="quantity" value="1">\n'
            html_docs+='<input type="hidden" name="id" value="$$id$$">\n'.replace('$$id$$',option2.id)
            if(option2.inventory_quantity>0){
                html_docs+='<button type="submit" class="js-cart-add" data-id="$$id$$" data-price="$$price$$"><img src="https://cdn.shopify.com/s/files/1/0481/4602/2552/files/product_btn_cartin.png?v=1700836216" class="js-notincart"><span class="js-incart">カートに入りました</span></button>\n'.replace('$$id$$',option2.id)
            }else{
                html_docs+='<button disabled class="nostock"><img src="https://cdn.shopify.com/s/files/1/0481/4602/2552/files/product_btn_soldout.png?v=1700836216"></button>\n'
            }
            html_docs+='</form>\n'
            html_docs+='</div>\n'
            html_docs+='</ul>\n'
            html_docs+='</li>\n'
        }
    }
    
    //console.log(html_docs)
    $('.cellec-cartbtn .cellec-cartbtn__options .option1').html(html_docs)
    console.log('-------cellec-cart.js--------')

    //オプション１のクリックでオプション２が表示
    $('.cellec-cartbtn__options .option1>li.n_option2>.box').on('click',function(){
        var id=$('a',this).data('btn')
        $('a',this).toggleClass('open')
        $('#js-option-' + String(id)).slideToggle(300)
        return false
    })

    //カートに入れるボタンを押すとオプション選択がせり出す
    $('#btn_cart').on('click',function(){
        $('.cellec-cartbtn').addClass('open')
        return false
    })

    $('.cellec-cartbtn__title .js-btn-close').on('click',function(){
        $('.cellec-cartbtn').removeClass('open')
        return false
    })

    //submit処理に介入し、cart.js　でカートに追加し、画面遷移をキャンセル
    $('.js-cart-add').on('click', function(e){
        var dom = $(this)
        var id= $(this).data('id')
        var price = $(this).data('price')
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
                items: [
                    // ここに追加する商品を記載
                    {
                        quantity:1,
                        id: id,
                        properties: {
                        }
                    }
                ]
            },
            dataType: 'json',
            success: function() {
                $(dom).addClass('cartin')
                cart_in_popup()
            },
            error: function() {
                console.log("add.js 読み込み失敗")
            }
        });
        return false
    })
})

window.addEventListener('load',function(){
    console.log('loaded')
    
    //お気に入りボタンを移動
    const breakpoint = 768
    if($(window).width() < breakpoint){
        let wishbtn = $('.wk-button-product')
        //console.log('お気に入りボタン',wishbtn[0])
        //$('#cellec-cartbtn__title').append(wishbtn[0])
    }
})



/**
 * カートに入れたときにポップアップを表示する
 */
function cart_in_popup(){
    console.log('cart_in_popup()')
    let freeship_line = 3980
    let price_total = 0
    let math_total = 0
    let text = ''
    fetch('/cart.js',{cache: "no-store"})
        .then(response => response.json())
        .then(data => {
            console.log('cart.jsからのデータ',data)
            price_total = (data.items_subtotal_price / 100)
            math_total = data.item_count
            if(price_total >= freeship_line){
                text = 'こちらのご注文は送料無料です。'
            }else{
                let price_free = freeship_line - price_total
                text = 'あと' + String(price_free.toLocaleString()) + '円で送料無料です。<br><small>※3,979円以下-送料無料の商品の場合にも表示されている場合がございます。</small><small>※沖縄県の場合は9,800円以上で送料無料となります。</small>'
            }      

            //HTMLを書き換え
            let el_math = document.querySelector('.js-popup-math')
            let el_price = document.querySelector('.js-popup-price')
            let el_text = document.querySelector('.js-popup-text')
            el_math.textContent = math_total
            el_price.textContent = price_total.toLocaleString()
            el_text.innerHTML = text

            //ポップアップを表示する
            let el_popup = document.querySelector('#js-cart_popup')
            el_popup.classList.remove('js-hidden')
        })
        .catch((error) => {
            console.error('Error:', error);
        });
}


/**
 *カートに入れた後のポップアップを閉じる 
 */
function close_popup(){
    console.log('ポップアップ閉じるボタンがクリックされました')
    let popup = document.querySelector('#js-cart_popup')
    let sp_sku_selector = document.querySelector('.cellec-cartbtn')
    popup.classList.add('js-hidden')
    //window.location.reload()
    sp_sku_selector.classList.remove('open')
    return false
}